module.exports = __webpack_public_path__ + "img/Arts & Crafts, School & Office.439a8f16.png";